/**
 * Formats a date string or Date object to a localized string
 * @param date - Date string or Date object to format
 * @returns Formatted date string
 */
export function formatDateTime(date: string | Date): string {
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    }).format(new Date(date));
}

/**
 * Formats a date for display with custom options
 * @param date - Date string or Date object to format
 * @param options - Intl.DateTimeFormatOptions
 * @returns Formatted date string
 */
export function formatDate(
    date: string | Date,
    options?: Intl.DateTimeFormatOptions
): string {
    return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
}

